"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    OptionGroup: function() {
        return _index.OptionGroup;
    },
    optionGroupClassNames: function() {
        return _index.optionGroupClassNames;
    },
    renderOptionGroup_unstable: function() {
        return _index.renderOptionGroup_unstable;
    },
    useOptionGroupStyles_unstable: function() {
        return _index.useOptionGroupStyles_unstable;
    },
    useOptionGroup_unstable: function() {
        return _index.useOptionGroup_unstable;
    }
});
const _index = require("./components/OptionGroup/index");
